module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/Block4_Mobile-0a502a8729cd3c4dae1bd73c445b4c8b.png";